import { defineStore } from 'pinia';
import { getConfigData } from '@/services/confService';

export const useConfigStore = defineStore('ConfigStore', {
  state: () => ({
    configData: {} as ConfigType | undefined,
  }),

  getters: {
    getConfigData(store) {
      return store.configData;
    },
  },

  actions: {
    async fetchConfigData() {
      const axiosResponse = await getConfigData();
      if (axiosResponse && axiosResponse.status === 200) {
        this.configData = {
          riaRestUrlPath: axiosResponse.data['ria.rest.url.path'],
          buildTimestamp: axiosResponse.data['build.timestamp'],
          quarkusApplicationVersion: axiosResponse.data['quarkus.application.version'],
          riaWebConfigOauthRealmBaseUrl: axiosResponse.data['ria.web.config.oauth.realm.base-url'],
          buildGitCommit: axiosResponse.data['build.git.commit'],
          riaWebConfigOauthRealmName: axiosResponse.data['ria.web.config.oauth.realm.name'],
          riaWebConfigOauthClientId: axiosResponse.data['ria.web.config.oauth.clientid'],
        };
      }
    },
  },
});
